export default {
    install(Vue, options = {}) {
        const vueSettings = {};
        if (typeof settings === 'object') {
            Object.keys(settings).forEach(key => {
                vueSettings[key] = settings[key];
            });
        }
        Object.keys(options).forEach(key => {
            vueSettings[key] = options[key];
        });
        Vue.prototype.$config = vueSettings;
        Vue.$config = vueSettings;
    }
};
